import { index, integer, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
export var SyncSweepStatusEnum;
(function (SyncSweepStatusEnum) {
    SyncSweepStatusEnum["Running"] = "running";
    SyncSweepStatusEnum["Completed"] = "completed";
    SyncSweepStatusEnum["PartialFailed"] = "partial_failed";
    SyncSweepStatusEnum["Failed"] = "failed";
})(SyncSweepStatusEnum || (SyncSweepStatusEnum = {}));
export var SyncId;
(function (SyncId) {
    SyncId["WEBSITE"] = "website";
    SyncId["NOTION"] = "notion";
    SyncId["POSTGRES"] = "postgres";
    SyncId["ANALYTICS"] = "analytics";
})(SyncId || (SyncId = {}));
export const syncSweeps = pgTable("sync_sweeps", {
    id: uuid("id").primaryKey().defaultRandom(),
    syncId: text("sync_id").$type().notNull(),
    status: text("status")
        .notNull()
        .$type()
        .default(SyncSweepStatusEnum.Running),
    lastCursor: text("last_cursor"),
    dueCount: integer("due_count").notNull().default(0),
    enqueuedCount: integer("enqueued_count").notNull().default(0),
    startedAt: timestamp("started_at", { withTimezone: true }).notNull().defaultNow(),
    completedAt: timestamp("completed_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    syncIdx: index("sync_sweeps_sync_id_status").on(table.syncId, table.status),
}));
